import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'
import React from 'react'

import ChatFeed from './ChatFeed'
import ChatFooter from './ChatFooter'
import ChatHeader from './ChatHeader'
import { Container } from './styles'

const PaperProps = {
    style: {
        backgroundColor: '#222222',
        width: '100%',
        height: '100%',
        padding: 0,
        margin: 0,
        borderRadius: 0,
        maxHeight: '100%',
    },
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const ChatModal = ({
    showChat,
    handleHideChat,
    onSendMsg,
    shouldShowTextInput,
}) => {
    return (
        <Dialog
            onClose={handleHideChat}
            aria-labelledby="customized-dialog-title"
            open={showChat}
            TransitionComponent={Transition}
            PaperProps={PaperProps}
        >
            <Container>
                <ChatHeader handleHideChat={handleHideChat} />
                <ChatFeed />
                {shouldShowTextInput && <ChatFooter onSendMsg={onSendMsg} />}
            </Container>
        </Dialog>
    )
}

export default React.memo(ChatModal)
